import React, { useEffect, useMemo } from "react";
import { TagsInput } from "@cadmakers-ui/core";
import { Tag, useTags } from "..";

type Props = {
  selectedIds: number[];
  onSelectedTagsChange: (tagIds: number[]) => void;
};

type TagsInputItem = {
  value: string | number;
  label: string;
};

const FeedbackTagPicker: React.FC<Props> = props => {
  const tags = useTags();

  const tagOptions = useMemo(() => {
    if (!tags.loadingState.isLoaded) {
      return [];
    }

    return tags.tags.map(t => ({
      value: t.id,
      label: t.name
    }));
  }, [tags]);

  const selectedValues = useMemo(() => {
    return tagOptions.filter(t => props.selectedIds.includes(t.value));
  }, [props.selectedIds, tagOptions]);

  const onTagsInputChange = (newValue: TagsInputItem | TagsInputItem[]) => {
    if (!newValue) {
      props.onSelectedTagsChange([]);
    } else if (Array.isArray(newValue)) {
      props.onSelectedTagsChange(newValue.map(v => v.value as number));
    } else {
      props.onSelectedTagsChange([newValue.value as number]);
    }
  };

  return <TagsInput options={tagOptions} value={selectedValues} onChange={onTagsInputChange} />;
};

export default FeedbackTagPicker;
